export default {
  201: {
    description:
      "**Created** - Request was successful and new source was created."
  },
  204: {
    description:
      "**No Content** - Request was successful. Response body is empty."
  },
  400: {
    description:
      "**Bad Request** - Server did not understand the request. Probably because of syntax error or data does not corresponds with rules for request."
  },
  401: {
    description:
      "**Unauthorized** -	Request require authentication. Authentication data in head are invalid or missing."
  },
  403: {
    description:
      "**Forbidden** - The source, that you are trying to access are not available fot his client/user."
  },
  404: {
    description:
      "**Not Found** - Server did not find any object that suit the request."
  },
  422: {
    description:
      "**Unprocessable Entity** - Server understood the request but he can not process because of invalid input or missing parameters."
  },
  500: {
    description:
      "**Internal Server Error** - Unexpected events happened on server which prevented successful accomplishment of request. This event has been automatically reported and will be fixed as soon as possible."
  }
};
